// @ts-strict-ignore
import React from 'react'
import { brand, pathname } from '../../redux/app-selectors'

import sw from '../../utils/switch'
import { connect } from 'react-redux'
import { findEntityBySysId, getHitsWithExtraData } from '../../redux/contentful-selectors'
import { getProductTableRelations } from '../../utils/contentful'

import TopPicks from './top-picks'
import AboveTheFold from './above-the-fold'
import { FsCore } from '../../types/fs-core'
import { getESProductDataSetData } from '../../redux/elasticsearch/elasticsearch-selectors'
import MoneyVoiceTopPicks from './money-voice-top-picks'

const TableSelector = (props) => {
  return sw({
    toppicks: () => <TopPicks {...props} />,
    moneyvoicetoppick: () => <MoneyVoiceTopPicks {...props} />,
    abovethefold: () => <AboveTheFold {...props} />,
    abovethefoldhorizontal: () => <AboveTheFold {...props} horizontal={true} />,
    abovethefoldwithborder: () => <AboveTheFold {...props} border={true} />,
  })(props.variant.toLowerCase())
}

const ConnectTable = connect((state: FsCore.State, props) => {
  const { variant, linkOutCard } = props

  const { productTableSchema, productDataset } = getProductTableRelations(state, {
    fields: props,
  })

  const hits = getHitsWithExtraData(state, productTableSchema.sys.id, productDataset.sys?.id)
  const fullProductData = getESProductDataSetData(state, props.dataset.sys.id)?.hits?.hits
  const linkOutCardEntity = linkOutCard && findEntityBySysId(state, linkOutCard.sys.id)

  return {
    ...productTableSchema.fields.schema,
    data: hits.length > 0 ? hits : productDataset?.fields?.data || [],
    variant,
    props,
    brand: brand(state),
    path: pathname(state),
    datasetId: productDataset.sys.id,
    schemaId: productTableSchema.sys.id,
    tableId: props.sys.id,
    reviews: state.reviews,
    fullProductData,
    linkOutCard: linkOutCardEntity,
  }
})(TableSelector)

export default ConnectTable
